export enum WageAndTravelReportType {    
    default = 0,
    yearEnd = 1,
    transactions = 2
}